import React from 'react';
import './Exports.css';

const Exports = () => {
  const products = [
    {
      id: 1,
      name: 'Soy Bean',
      image: 'images/Soy-Bean.jpg',
      description: 'Export premium quality soybean from Africa with ABVIG. Our soybeans are sourced from the finest farms across the continent.',
      link: '/soybean'
    },
    {
      id: 2,
      name: 'Sesame',
      image: 'images/Sesame.jpg',
      description: 'Export high-quality sesame seeds from Africa. Our sesame is carefully selected and processed to meet international standards.',
      link: '/sesame'
    },
    {
      id: 3,
      name: 'Urea / Nitrogenous Fertilizer',
      image: 'images/urea.png',
      description: 'Buy high-quality and sustainable urea fertilizer from Africa. Our fertilizer supports agricultural growth across the continent.',
      link: '/urea-fertilizer'
    },
    {
      id: 4,
      name: 'Cotton',
      image: 'images/cotton.jpg',
      description: 'Buy sustainable and equitable cotton from Africa. Our cotton is ethically sourced and processed with care.',
      link: '/cotton'
    }
  ];

  return (
    <div className="exports-page">
      {/* Hero Section */}
      <section 
        className="exports-hero"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(43, 15, 5, 0.88) 0%, rgba(74, 51, 38, 0.75) 50%, rgba(43, 15, 5, 0.88) 100%), url('/images/exports-hero.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="exports-hero-overlay"></div>
        <div className="exports-hero-content">
          <span className="exports-badge">ABVIG Exports</span>
          <h1>Exports & Turnkey Solutions</h1>
          <p className="exports-subtitle">
            Empowering Africa's Economic Growth: The ABVIG Mission to Foster Trade, 
            Investment, and Sustainable Agriculture for a Flourishing Continent.
          </p>
          <p className="exports-description">
            Get turnkey solutions with full logistical facilitation.
          </p>
          <button className="btn-gold" onClick={() => window.location.href = '/contact-us'}>
            CONTACT ABVIG
          </button>
        </div>
      </section>

      {/* Products Grid */}
      <section className="products-section">
        <div className="container">
          <h2 className="section-title">Our Export Products</h2>
          <div className="products-grid">
            {products.map((product) => (
              <div className="product-card" key={product.id}>
                <div 
                  className="product-image" 
                  style={{backgroundImage: `url(${product.image})`}}
                ></div>
                <div className="product-content">
                  <h3>Export {product.name} from Africa with ABVIG</h3>
                  <p>{product.description}</p>
                  <button className="btn-gold product-btn" onClick={() => window.location.href = product.link}>
                    READ MORE
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Turnkey Solutions Section */}
      <section className="turnkey-section">
        <div className="container">
          <div className="turnkey-content">
            <h2>Facilitating the Process</h2>
            <p>
              Discover limitless possibilities for your business with ABVIG's top-of-the-line 
              equipment rental services. We offer seamless and efficient trade solutions to bring 
              your investment to new heights.
            </p>
            <p>
              Our turnkey solutions provide a hassle-free experience to make your journey to 
              success an enjoyable one. With ABVIG, you can expect nothing less than excellence 
              in equipment rental services that enable you to streamline your business operations. 
              Start your journey today with us and experience the difference.
            </p>
            <button className="btn-gold" onClick={() => window.location.href = '/contact-us'}>
              INQUIRE NOW ABOUT TURNKEY SOLUTIONS
            </button>
          </div>
        </div>
      </section>

      {/* VIP Services CTA */}
      <section className="vip-cta-section">
        <div className="container">
          <div className="vip-cta-content">
            <h2>Explore Opportunity in Style</h2>
            <p>Travel from destination to destination without the mundane.</p>
            <button className="btn-outline-gold" onClick={() => window.location.href = '/vip-services'}>
              VIP SERVICES
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Exports;